module.exports = __webpack_public_path__ + "static/img/1842.a242a5a.png";